import styled from 'styled-components';

import { Button, GridRow } from 'libs/ui';

export const Row = styled(GridRow)``;

export const ImageWrap = styled.div`
  height: 300px;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 !important;
`;

export const ClosePicturesButton = styled(Button)`
  position: absolute;
  bottom: 15px;
  left: 46%;
`;
